<!--  -->
<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
        :offset="1"
      >
        <div class="item" @click="navDetails(item.url,item.article_id)" v-for="(item, index) in list" :key="index">
          <p>{{item.title}}</p>
          <div class="item-kind">
            <span>{{name}}</span>
            <span>{{item.create_time}}</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getArticle } from "@/api/apiData";
export default {
  components: {},
  props: ["index", "id", "name"],
  data() {
    return {
      page: 0, //当前页码
      offset: 10, //当前条目数
      totalPages: 1, //总页码
      list: [],
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {},
  methods: {
    navDetails(url,id) {
      if (url.length > 0) {
        window.location.href = url;
      } else {
        this.$router.push({
          name: "interDetails",
          params:{
            id:id
          }
        });
      }
    },
    // 上拉加载
    onLoad() {
      //(11);
      var that = this;
      that.getList();
    },
    // 下拉刷新
    onRefresh() {
      //(22);
      var that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.loading = false;
      that.finished = false;
      setTimeout(() => {
        that.getList();
        that.refreshing = false;
      }, 1500);
    },
    // 获取文章列表
    getList() {
      var that = this;
      var page = that.page + 1;
      var totalPages = that.totalPages;
      var list = that.list;
      var offset = that.offset;
      var id = that.id;
      // //(id);
      var obj = {
        page: page,
        offset: offset,
        channel_id: id
      };
      if (page <= totalPages) {
        getArticle(obj).then(res => {
          //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            that.page = page;

            if (res.data.list.length == 0) {
              that.loading = false;
              that.finished = true;
              return false;
            }
            if (that.list.length > list.length) {
              setTimeout(() => {
                that.loading = false;
              }, 3000);
            }
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style lang='less' scoped>
.item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.32rem 0 0.28rem;
  border-bottom: 0.01rem solid #ddd;
  p {
    font-size: 0.3rem;
    font-weight: bold;
    line-height: 0.42rem;
    color: rgba(51, 51, 51, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .item-kind {
    display: flex;
    margin-top: 0.2rem;
    align-items: center;

    span:nth-child(1) {
      background: #b7a36d;
      border-radius: 0.04rem;
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(255, 255, 255, 1);
      padding: 0.1rem;
    }
    span:nth-child(2) {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
      margin-left: 0.16rem;
    }
    .item-mode {
      background: rgba(75, 183, 255, 1);
      border-radius: 0.04rem;
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(255, 255, 255, 1);
      padding: 0.1rem;
    }
  }
}
</style>